import React from 'react'
import { Radio, FormControlLabel, RadioGroup } from '@mui/material'
import { useStyles } from './style'

const QuestionVariability = ({ handleSend, initialValue }) => {
  const { variabilityRoot, radioLabel, radioRoot, radioRootLabel } = useStyles()
  const [value, setValue] = React.useState(initialValue)


  const handleChange = (event) => {
    const value = parseInt(event.target.value)
    setValue(value)
    handleSend({ variabilityValue: value })
  }

  return (
    <div className={variabilityRoot}>
      <RadioGroup name='variability' value={value} onChange={handleChange} row>
        <FormControlLabel
          className={radioLabel}
          classes={{ label: radioRootLabel }}
          value={1}
          label='Variability Low'
          labelPlacement='bottom'
          control={<Radio classes={{ checked: initialValue ? radioRoot : null }} />}
        />
        <FormControlLabel
          className={radioLabel}
          classes={{ label: radioRootLabel }}
          value={2}
          label='Variability Medium'
          labelPlacement='bottom'
          control={<Radio classes={{ checked: initialValue ? radioRoot : null }} />}
        />
        <FormControlLabel
          className={radioLabel}
          classes={{ label: radioRootLabel }}
          value={3}
          label='Variability High'
          labelPlacement='bottom'
          control={<Radio classes={{ checked: initialValue ? radioRoot : null }} />}
        />
      </RadioGroup>
    </div>
  )
}

export default QuestionVariability
